import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { ROLES_DETAIL } from "@/data/roles";

const EXPLORE_LINKS = [
  { to: "/", label: "Home" },
  { to: "/talent", label: "Cloud & Data Talent" },
  { to: "/join", label: "Join the bench" },
  { to: "/resources", label: "Resources" },
  { to: "/articles", label: "Articles" },
  { to: "/technologies", label: "Technologies" },
  { to: "/calculator", label: "Cost calculator" },
  { to: "/glossary", label: "Glossary" },
  { to: "/faq", label: "FAQ" },
];

const COMPARE_LINKS = [
  { to: "/compare", label: "nearcore vs the alternatives" },
  { to: "/compare/nearshore-staff-augmentation", label: "vs traditional nearshore staffing" },
  { to: "/compare/boutique-staffing", label: "Why boutique wins" },
];

const linkClass =
  "text-sm text-white/70 transition-colors duration-300 hover:text-white";

const colTitle =
  "font-cond text-xs font-bold uppercase tracking-[0.22em] text-white/50";

export default function Footer() {
  return (
    <footer className="bg-[#03383F]" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
        <div>
          <p className="font-display text-2xl font-extrabold lowercase tracking-tight text-white">
            nearcore
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/70">
            Boutique nearshore staff augmentation. Senior Data &amp; Cloud talent, USA time zone.
          </p>
        </div>
        <nav aria-label="Explore">
          <p className={colTitle}>Explore</p>
          <ul className="mt-4 space-y-2.5">
            {EXPLORE_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className={linkClass} data-testid={`footer-explore-${link.label.toLowerCase().replace(/[\s&]+/g, "-")}`}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Compare">
          <p className={colTitle}>Compare</p>
          <ul className="mt-4 space-y-2.5">
            {COMPARE_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className={linkClass} data-testid={`footer-compare-${link.to.split("/").pop()}`}>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Roles">
          <p className={colTitle}>Hire a senior</p>
          <ul className="mt-4 space-y-2.5">
            {ROLES_DETAIL.map((role) => (
              <li key={role.slug}>
                <Link to={`/roles/${role.slug}`} className={linkClass} data-testid={`footer-role-${role.slug}`}>
                  {role.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-white/20">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-5 py-6 sm:px-8">
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/nearcore-io/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="nearcore on LinkedIn"
              data-testid="footer-linkedin-link"
              className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#f5b81e] text-white transition-transform duration-300 hover:scale-110"
            >
              <Linkedin size={20} fill="currentColor" strokeWidth={0} />
            </a>
            <p className="text-xs text-white/60" data-testid="footer-copyright">
              © 2026 nearcore · Cloud &amp; Data Talent. All rights reserved.
            </p>
          </div>
          <div className="text-right leading-none">
            <span className="block font-display text-xl font-extrabold lowercase tracking-tight text-white">
              nearcore
            </span>
            <span className="mt-1 block text-[10px] font-medium tracking-[0.18em] text-white/60">
              Cloud &amp; Data Talent
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
